import { Link } from 'react-router-dom';
import startPosting from '../../images/start-working.png';
import "./PostTalentCard.scss"

function PostTalentCard({ name, subject, img, to }) {
    return (
        <div className="talent-card">
            <div className="icon"><img src={img} alt='job'></img></div>
            <div className="talent-content-wrp">
                <div className="jc-title">{name}</div>
                <div className="jc-subject">{subject}</div>
                <div className="jc-start-posting-wrp">
                    <Link reloadDocument={true} to={to}>
                        <div className="title">Start Working</div>
                        <img src={startPosting} alt='start-working'></img>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default PostTalentCard;